import {
	Grid2,
	Typography,
	Checkbox,
	Button,
	InputBase,
	ButtonBase,
	Box,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { helperText } from '../assets/theme/Theme';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
// import { getRememberMe, setRememberMe } from '../Utils/AuthUtil';
// import { loginUser } from '../services/UserService';
// import Logo from '../assets/images/Logo.png';
import { EyeIcon, HideEyeIcon } from '../assets/icons/Icons';
import LoginImage from '../assets/images/LoginImage.png';
import {
	getRememberMe,
	setAccessToken,
	setAgencyId,
	setAllFeatureLimitStatus,
	setExpireTime,
	setFeatureLimit,
	setFeatureLimitStatus,
	setRememberMe,
	setUserName,
	setUserRole,
} from '../Utils/AuthUtil';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';
import {
	fetchGuestUserLimits,
	fetchUser,
	loginUser,
} from '../services/UserService';
import { LoginResponse } from '../types';

const initialErrorState = {
	status: false,
	msg: '',
};

function Login() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const navigator = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [remember, setRemember] = useState(0);
	const [emailError, setEmailError] = useState(initialErrorState);
	const [passwordError, setPasswordError] = useState(initialErrorState);
	const [loginStatus, setLoginStatus] = useState(initialErrorState);
	const [show, setShow] = useState(false);

	function onChangeEmail(
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) {
		setEmailError(initialErrorState);
		setEmail(event.target.value);
	}

	function onChangePassword(
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) {
		setPasswordError(initialErrorState);
		setPassword(event.target.value);
	}

	async function logIn() {
		let error = false;
		if (!email || email === '') {
			setEmailError({ status: true, msg: 'Email is Required.' });
			error = true;
		}

		if (email !== '' && email.indexOf('@') === -1) {
			setEmailError({ status: true, msg: 'Invalid Email' });
			error = true;
		}

		if (!password || password === '') {
			setPasswordError({ status: true, msg: 'Password is Required.' });
			error = true;
		}

		if (error) {
			return;
		} else {
			setLoginStatus(initialErrorState);

			const response: LoginResponse | undefined = await loginUser(
				email,
				password,
			);

			if (response?.data?.status === 200 && response?.data.role === 100) {
				fetchUserData(response?.data?.userId, response?.data?.token);
				setExpireTime();
				navigator('/home');
			} else if (
				response?.data?.status === 200 &&
				response?.data.role === 1000
			) {
				setUserName('Super Admin');
				setExpireTime('superAdmin');
				navigator('/admins');
			} else if (response?.data?.status === 400) {
				setLoginStatus({
					status: true,
					msg: 'Email or password is incorrect',
				});
			} else {
				setLoginStatus({
					status: true,
					msg: 'Something went wrong, please try again.',
				});
			}
		}
	}

	async function fetchUserData(id: string, token: string) {
		const data = await fetchUser(id, token);
		const limitData = await fetchGuestUserLimits(id, token);

		if (data.content) {
			setFeatureLimit(data.content.featureLimit);
			setAgencyId(data.content.agencyId);
			setUserName(data.content.username);
		}

		if (!limitData.error) {
			setAllFeatureLimitStatus(data.isAllLimitReached);
			setFeatureLimitStatus(data.reachedLimits);
		}
	}

	const onChangeRememberMe = () => {
		const val: number = Number(getRememberMe());
		if (val === 0 || val === 2) {
			setRemember(1);
			setRememberMe('1');
		}
		if (val === 1) {
			setRemember(0);
			setRememberMe('0');
		}
	};

	return (
		<Grid2
			container
			sx={{
				padding: '10px',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh',
				display: 'flex',
				backgroundColor: '#f1f9f8',
			}}>
			<Grid2
				container
				sx={{
					width: '80%',
					height: '100%',
				}}>
				<Grid2
					component={'div'}
					size={{ xs: 12, md: 6 }}
					sx={{
						height: 'calc(100vh - 25px)',
						backgroundColor: '#fff',
						overflow: 'hidden',
						boxShadow:
							'inset 0px -200px 80px -60px rgba(40, 105, 109, 0.5)',
					}}>
					<Box position="relative" width="100%" height={'100%'}>
						<Box
							component="img"
							src={LoginImage}
							width="100%"
							height="100%"
							sx={{ objectFit: 'contain' }}
						/>
						<Box
							position="absolute"
							bottom={isMobile ? 100 : 160}
							left={0}
							width={isMobile ? '90%' : '95%'}
							color="white"
							textAlign={'center'}
							p={2}>
							<Typography
								fontSize={'20px'}
								fontWeight={'600'}
								color={MAIN_THEME_COLOR}>
								Welcome to Trip Planner.Ai : AI Bot. Seamless
								Control
							</Typography>
							<Typography
								fontSize={'12px'}
								fontWeight={'400'}
								color={'#000000'}
								marginTop={'5px'}>
								Manage customer interactions with Open View,
								take over anytime with Manual Chat, and power
								your assistant using Knowledge Studio.
							</Typography>
						</Box>
					</Box>
				</Grid2>
				<Grid2
					component={'div'}
					sx={{
						height: 'calc(100vh - 25px)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'column',
						backgroundColor: '#FFFFFF',
						boxShadow: '0px 10px 110px 1px rgba(59, 59, 59, 0.08)',
					}}
					size={{ xs: 12, md: 6 }}>
					<Grid2 container width={'85%'} flexDirection={'column'}>
						<Typography
							variant="h4"
							fontWeight={'700'}
							color={MAIN_THEME_COLOR}>
							{`Trip Planner.Ai`}
						</Typography>
						<Typography
							fontSize={'18px'}
							fontWeight={'600'}
							marginTop={'10px'}>
							Login to your Trip Planner.Ai Account
						</Typography>
					</Grid2>
					<Grid2
						component="div"
						size={{ xs: 12, md: 12 }}
						style={{
							textAlign: 'left',
							marginTop: '20px',
							padding: isMobile ? '20px' : '50px',
							borderRadius: '10px',
						}}>
						<Typography
							fontSize={'16px'}
							color={'#000000'}
							paddingBottom="10px">
							Email
						</Typography>
						<Grid2
							container
							justifyContent={'space-between'}
							alignItems={'center'}
							border={
								passwordError.status
									? '1px solid red'
									: '1px solid #D9D9D9'
							}
							color={'#777E90'}
							paddingX={'15px'}
							borderRadius={'5px'}>
							<InputBase
								type={'text'}
								sx={{
									padding: '4px',
									width: '100%',
									color: '#777E90',
								}}
								error={emailError.status}
								onChange={onChangeEmail}
								onKeyPress={e => e.code === 'Enter' && logIn()}
							/>
						</Grid2>
						<Typography style={helperText}>
							{emailError.msg}
						</Typography>
						<Typography
							fontSize={'16px'}
							color={'#000000'}
							paddingY="10px">
							Password
						</Typography>
						<Grid2
							container
							justifyContent={'space-between'}
							alignItems={'center'}
							border={
								passwordError.status
									? '1px solid red'
									: '1px solid #D9D9D9'
							}
							color={'#777E90'}
							paddingX={'15px'}
							borderRadius={'5px'}>
							<InputBase
								type={show === false ? 'password' : 'text'}
								sx={{
									padding: '4px',
									width: { md: '90%', xs: '80%' },
									color: '#777E90',
								}}
								error={passwordError.status}
								onChange={onChangePassword}
								onKeyPress={e => e.code === 'Enter' && logIn()}
							/>
							<ButtonBase onClick={() => setShow(!show)}>
								{show ? (
									<HideEyeIcon error={passwordError.status} />
								) : (
									<EyeIcon error={passwordError.status} />
								)}
							</ButtonBase>
						</Grid2>
						<Typography style={helperText}>
							{passwordError.msg}
						</Typography>
						<Grid2 container justifyContent={'space-between'}>
							<Grid2>
								<Checkbox
									style={{
										paddingLeft: '0px',
										paddingRight: '0px',
									}}
									size="small"
									color="success"
									disableRipple
									onChange={() => onChangeRememberMe()}
									checked={remember === 0 ? false : true}
								/>
								<Typography
									variant="subtitle2"
									style={{
										display: 'inline',
										color: '#10292B',
										paddingLeft: '2px',
									}}>
									Remember me
								</Typography>
							</Grid2>
							{/* <a style={{ textDecoration: 'none' }} href="/reset">
								<Typography
									variant="subtitle2"
									color={MAIN_THEME_COLOR}
									style={{ paddingTop: '10px' }}>
									Forgot your password?
								</Typography>
							</a> */}
						</Grid2>
						{loginStatus.status && (
							<Grid2 container justifyContent={'center'}>
								<Typography style={helperText}>
									{loginStatus.msg}
								</Typography>
							</Grid2>
						)}
						<Grid2 container>
							<Button
								onClick={logIn}
								style={{
									width: '100%',
									boxShadow: 'none',
									marginTop: '10px',
									textTransform: 'none',
									backgroundColor: MAIN_THEME_COLOR,
								}}
								variant="contained">
								Log in
							</Button>
							<Grid2
								container
								flexDirection={'row'}
								paddingY={'15px'}>
								<Typography
									variant="subtitle2"
									color={'#777E91'}>
									Create a new account
								</Typography>
								<Typography
									variant="subtitle2"
									style={{
										color: '#28696D',
										paddingLeft: '3px',
									}}>
									<a
										href="/createAccount"
										style={{ textDecoration: 'none' }}>
										<span
											style={{
												color: '#28696D',
												cursor: 'pointer',
												textDecoration: 'underline',
											}}>
											Signup
										</span>
									</a>
								</Typography>
							</Grid2>
						</Grid2>
					</Grid2>
				</Grid2>
			</Grid2>
		</Grid2>
	);
}

export default Login;
